/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Meta_Description1Inputs */

const id_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game terbaru yang diumumkan dan dinominasikan di The Game Awards yang hadir di Epic Games Store.`)
};

const ms_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan terkini diumumkan dan dicalonkan di The Game Awards yang akan datang ke Epic Games Store.`)
};

const da_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste spil annonceret og nomineret ved The Game Awards der kommer til Epic Games Store.`)
};

const de_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste bei The Game Awards angekündigte und nominierte Spiele, die in den Epic Games Store kommen.`)
};

const en_us2_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest games announced and nominated at The Game Awards coming to Epic Games Store.`)
};

const es_es2_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los últimos juegos anunciados y nominados en The Game Awards que llegan a la Epic Games Store.`)
};

const es_mx2_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los últimos juegos anunciados y nominados en The Game Awards que llegan a la Epic Games Store.`)
};

const fil_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pinakabagong larong inanunsyo at hinirang sa The Game Awards na darating sa Epic Games Store.`)
};

const fr_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derniers jeux annoncés et nommés aux Game Awards arrivant sur l'Epic Games Store.`)
};

const it_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi giochi annunciati e nominati ai The Game Awards in arrivo sull'Epic Games Store.`)
};

const hu_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb játékok, amelyeket a The Game Awards-on jelentettek be vagy jelöltek, és érkeznek az Epic Games Store-ba.`)
};

const nl_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste games aangekondigd en genomineerd bij The Game Awards die naar de Epic Games Store komen.`)
};

const no_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste spill annonsert og nominert på The Game Awards som kommer til Epic Games Store.`)
};

const pl_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze gry ogłoszone i nominowane podczas The Game Awards trafiające do Epic Games Store.`)
};

const pt_br2_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos jogos anunciados e indicados em The Game Awards chegando a Epic Games Store.`)
};

const pt_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos jogos anunciados e nomeados nos The Game Awards a chegar à Epic Games Store.`)
};

const ro_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai recente jocuri anunțate și nominalizate la The Game Awards care ajung pe Epic Games Store.`)
};

const fi_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät The Game Awards -tapahtumassa ilmoitetut ja ehdokkaat pelit tulossa Epic Games Storeen.`)
};

const sv_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste spelen som tillkännages och nomineras på The Game Awards som kommer till Epic Games Store.`)
};

const vi_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các game mới nhất được công bố và đề cử tại The Game Awards sắp có mặt trên Epic Games Store.`)
};

const tr_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards'ta duyurulan ve aday gösterilen, Epic Games Store'a gelecek en son oyunlar.`)
};

const cs_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější hry oznámené a nominované na The Game Awards přicházející na Epic Games Store.`)
};

const bg_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-новите игри, обявени и номинирани на The Game Awards, които идват в Epic Games Store.`)
};

const ru_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние игры, анонсированные и номинированные на The Game Awards, выходящие в Epic Games Store.`)
};

const uk_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні ігри, анонсовані та номіновані на The Game Awards, що з'являться в Epic Games Store.`)
};

const ar_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث الألعاب التي تم الإعلان عنها وترشيحها في The Game Awards والقادمة إلى Epic Games Store.`)
};

const hi_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द गेम अवार्ड्स में घोषित नवीनतम गेम।`)
};

const th_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมล่าสุดที่ประกาศและได้รับการเสนอชื่อใน The Game Awards ที่จะมาใน Epic Games Store`)
};

const ja_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards で発表・ノミネートされ、Epic Games Store に登場する最新ゲーム。`)
};

const zh_cn2_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将登陆 Epic Games Store 的 The Game Awards 最新公布和提名游戏。`)
};

const zh_hant1_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將登陸 Epic Games Store 的 The Game Awards 最新公布和提名遊戲。`)
};

const ko_misc_gameawards_meta_description1 = /** @type {(inputs: Misc_Gameawards_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards에서 발표 및 후보에 오른 Epic Games Store 출시 예정 최신 게임.`)
};

/**
* | output |
* | --- |
* | "Latest games announced and nominated at The Game Awards coming to Epic Games Store." |
*
* @param {Misc_Gameawards_Meta_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_meta_description1 = /** @type {((inputs?: Misc_Gameawards_Meta_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Meta_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_meta_description1(inputs)
	if (locale === "ms") return ms_misc_gameawards_meta_description1(inputs)
	if (locale === "da") return da_misc_gameawards_meta_description1(inputs)
	if (locale === "de") return de_misc_gameawards_meta_description1(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_meta_description1(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_meta_description1(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_meta_description1(inputs)
	if (locale === "fil") return fil_misc_gameawards_meta_description1(inputs)
	if (locale === "fr") return fr_misc_gameawards_meta_description1(inputs)
	if (locale === "it") return it_misc_gameawards_meta_description1(inputs)
	if (locale === "hu") return hu_misc_gameawards_meta_description1(inputs)
	if (locale === "nl") return nl_misc_gameawards_meta_description1(inputs)
	if (locale === "no") return no_misc_gameawards_meta_description1(inputs)
	if (locale === "pl") return pl_misc_gameawards_meta_description1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_meta_description1(inputs)
	if (locale === "pt") return pt_misc_gameawards_meta_description1(inputs)
	if (locale === "ro") return ro_misc_gameawards_meta_description1(inputs)
	if (locale === "fi") return fi_misc_gameawards_meta_description1(inputs)
	if (locale === "sv") return sv_misc_gameawards_meta_description1(inputs)
	if (locale === "vi") return vi_misc_gameawards_meta_description1(inputs)
	if (locale === "tr") return tr_misc_gameawards_meta_description1(inputs)
	if (locale === "cs") return cs_misc_gameawards_meta_description1(inputs)
	if (locale === "bg") return bg_misc_gameawards_meta_description1(inputs)
	if (locale === "ru") return ru_misc_gameawards_meta_description1(inputs)
	if (locale === "uk") return uk_misc_gameawards_meta_description1(inputs)
	if (locale === "ar") return ar_misc_gameawards_meta_description1(inputs)
	if (locale === "hi") return hi_misc_gameawards_meta_description1(inputs)
	if (locale === "th") return th_misc_gameawards_meta_description1(inputs)
	if (locale === "ja") return ja_misc_gameawards_meta_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_meta_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_meta_description1(inputs)
	return ko_misc_gameawards_meta_description1(inputs)
});
export { misc_gameawards_meta_description1 as "misc.gameAwards.meta.description" }